import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faBell, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { VehiclePredefinedFilter } from 'features/vehicles/companyVehicles';
import type { JSX } from 'react';


type Props = {
    totalVehicles: number
    message: JSX.Element,
    filter: VehiclePredefinedFilter,
    activeFilter: VehiclePredefinedFilter,
    onToggleButton: Function,
    icon?: IconDefinition
}

const NotificationBox = (props: Props) =>
    props.totalVehicles ? (
        <div className="board-content radius-rectangle notification">
            <div className="notification-text">
                <FontAwesomeIcon icon={props.icon ?? faBell} className="fa-icon" />
                {props.message}
            </div>

            {props.filter === props.activeFilter ? (
                <button className="btn-small-blue" onClick={() => props.onToggleButton('filter', '')}>
                    <FontAwesomeIcon icon={faEyeSlash} className="fa-icon" />
                    <FormattedMessage id="GLOBAL_HIDE" />
                </button>
            ) : (
                <button className="btn-small-blue" onClick={() => props.onToggleButton('filter', props.filter)}>
                    <FontAwesomeIcon icon={faEye} className="fa-icon" />
                    <FormattedMessage id="GLOBAL_SHOW" />
                </button>
            )}
        </div>
    ) : null;

export default NotificationBox;